// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page{height:calc(100vh - 38px - 80px)}`, "",{"version":3,"sources":["webpack://./src/pages/error-pages/error-404.scss"],"names":[],"mappings":"AAAA,YACE,gCAAA","sourcesContent":[".error-page {\n  height: calc(100vh - 38px - 80px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
